export function compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
        a = a.trim().toLowerCase();
    }
    if (typeof b === 'string') {
        b = b.trim().toLowerCase();
    }
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
